var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComputerLine = function SvgComputerLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.3 15.6h14.4V5.7H5.3zm8.1 1.8v1.8H17V21H8v-1.8h3.6v-1.8H4.393a.897.897 0 0 1-.893-.906V4.807c0-.5.41-.907.893-.907h16.214c.493 0 .893.404.893.907v11.687c0 .5-.41.906-.893.906z"
  })));
};
export default SvgComputerLine;